// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";


// export default function Token() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                         <div>

//                   <h1>DGFT Digital Signature (e-Token)</h1>
//                   <p>Export and Import Organizations can now easily employ Digital Signature Certificates for document authentication thanks to the Digital Signature for Foreign Trade (DGFT) initiative.</p>
//                   <p>DGFT maintains a specialised DGFT site where users can upload electronic documents in one location. This aids foreign organisations (IET) in maintaining the security of their online transactions. With the rise in foreign organisations' online transactions, the DGFT advises customers to choose a class 3 Digital Signature Certificate, which can readily avoid fraudulent operations.</p>
            
//                                   <h2>What is a Digital Signature and How Does It Work?</h2>
//                                   <p>In simple terms, a Digital Signature Certificate is an encrypted file that is created by a Licensed Certifying Authority and then provided to you in the form of a USB eToken. When you sign a document, this file is accessed, and it works as a "key" (Private Key), locking and securing the document you're signing (through encryption). [This is analogous to locking your goods in a bank locker with a key — a lock can only be opened by its own key.]</p>
                    
//                     </div>
//                  </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <p>This file not only locks the document being signed, but it also adds a Digital Certificate to it that contains your identifying details, such as your name, organization's name, email address, and so on.</p>
                                  
//                                   <h2>Benefits of Digital Signature</h2>
//                                   <ul>
//                                       <li>Cost Savings</li>
//                                       <li>Exporters and Importers who use Safe EXIM to connect with DGFT online are eligible for substantial monetary incentives, including a 50% licencing fee remission.</li>
//                                       <li>Safe EXIM also reduces paperwork for the user, lowering associated costs.</li>
//                                       <li>The DGFT's licence issuance turnaround time has been reduced.</li>
//                                       <li>Convenience\sSecurity</li>
//                                       <li>Safe EXIM login to the DGFT portal (http://www.dgft.gov.in) is significantly more secure than a user ID/Password method. Online, no one can spoof you or your company.</li>
//                                   </ul>

//                                   <h2>What are the applications for Digital Signature Certificates?</h2>
//                                   <p>Digital Signature Certificates can be used for the following:</p>
//                                   <ul>
//                                       <li>To protect email and web-based transactions, or to identify other web-based transaction participants.</li>
//                                       <li>To establish SSL/ TLS encrypted protected sessions between your website and the user for web based transactions and to prove domain name ownership.</li>
//                                       <li>As a developer, you are responsible for confirming code authorship and maintaining the integrity of distributed software applications.</li>
//                                       <li>To sign web forms, e-tendering papers, file income tax returns, and automatically access membership-based websites without entering a user name and password, among other things.</li>
//                                   </ul>

//                                   <h2>For the DGFT, a digital signature is required.</h2>
//                                   <p>Any organisation seeking an import or export authorization could use a Class 2 or Class 3 Digital Signature Certificate. These applications are submitted on behalf of their respective organisations by a representative or signing authority.</p>
//                                   <p>DSCs are recognised by the legal system of DGFT websites, and all documents signed with a DSC are treated the same as physically signed papers. We also entice them to take use of the benefits granted to them under the Indian Information Technology Act of 2000.</p>
                                  
//                                   <h2>Who is eligible for a DGFT Digital Signature Certificate?</h2>
//                                   <p>Any authorised individual on behalf of his organisation can receive a DGFT DSC by submitting the appropriate documentation and undergoing verification. The DGFT Department shall offer an IEC Code and an IEC Certificate to the organisation.</p>
//                                   <p>If you need a digital signature for dgft or a dgft dsc for a DGFT website to communicate for various transactions, eSolutions is the ideal place to go. Your search for a digital signature required for dgft or documents required for dgft digital signature ends here.</p>
//                                   <p>Many individuals look for information on how to get a digital signature for dgft, documents required for dgft dsc, or a paperless dgft digital signature provider, and Apex Services is the place to go.</p>
//                                   <p>Every year, the DGFT Department has issued a notification for applying and upgrading IEC (now e-IEC). Every year, from April to June, it is required to update all IEC details, even if they remain the same, for all existing holders. IEC may be de-activated if it is not upgraded. DGFT Digital Signature is necessary to update or renew IEC.</p>
                             
//                                     <h2>Who can opt for a DGFT Digital Signature Certificate?</h2>
//                                     <p>Any authorised individual on behalf of his organisation can receive a DGFT DSC by submitting the appropriate documentation and undergoing verification. The DGFT Department shall offer an IEC Code and an IEC Certificate to the organisation.</p>

//                                   <h2>IMPORTANT NOTES:</h2>
//                                   <p>The following conditions will apply to the above papers.</p>
//                                   <p>I. Signature verification on application forms: At least one identity or address evidence must include the applicant's signature. If they are not present, subscribers should submit signatures that have been confirmed by the bank where they have a bank account.</p>
//                                   <p>II. Validity of the Address Proof: In the case of any utility bills in the name of the applicant, such as electricity, water, gas, or telephone bills, the most recent proof, but not older than 3 months from the date of application, should be provided. The address on the Address Proof must correspond to the address on the Application Form.</p>
//                                   <p>III. Only use blue ink for all signatures, including those of the DSC Applicant and approved person</p>
//                                   <p>IV. The attesting officer's name, designation, office address, and phone number should be plainly apparent.</p>
//                                   <p>V. In the DSC application form, the DSC applicant's cell number and e-mail address are required and must be unique.</p>
//                                   <p>VI. Section 3 of the application form should have the applicant's signature, and Section 4 should include the signature of an Authorized Person with a Designation Seal.</p>
//                                   <p>VII. The applicant's address must match one of the Organization Address Proofs.</p>
                             
//                                   <h2>At Apex Services What We Do</h2>
//                                   <p>We help in curating the perfect authorisation of the e-signature for improving the responsive time taken at DGFT. Furthermore, it will allow the filing of any online applications to DGFT. Regardless of the authorisation process, we are here to ensure a perfectly secure and privacy embedded digital signature.</p>
                             
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaLock,
  FaList,
  FaRocket,
  FaUser,
  FaFileInvoice,
  FaSyncAlt,
  FaHandsHelping
} from "react-icons/fa";

export default function Token() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col lg={8}>
              <h1>
                DGFT Digital Signature (E-Token)
              </h1>

              <p>
                A Digital Signature Certificate (DSC) is a secure electronic key
                issued by a licensed Certifying Authority. It is used to digitally
                sign documents, verify identity, and securely perform DGFT transactions.
              </p>

              <p>
                DSC is typically provided as a USB e-Token, ensuring safe usage
                and protection against unauthorized access. It is mandatory for
                DGFT filings and legally valid under the Information Technology Act.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your assistance section here */}
            </Col>

          </Row>

          {/* WHAT IS DSC */}
          <h2 className="section-title">
            <FaLock className="icon" /> What is a Digital Signature?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Used to sign documents digitally</li>
            <li><FaCheckCircle /> Verifies identity online</li>
            <li><FaCheckCircle /> Secures DGFT transactions</li>
            <li><FaCheckCircle /> Provided as USB e-Token</li>
          </ul>

          {/* HOW IT WORKS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> How It Works
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Contains encrypted private key</li>
            <li><FaCheckCircle /> Locks the document during signing</li>
            <li><FaCheckCircle /> Prevents tampering</li>
            <li><FaCheckCircle /> Confirms signer identity</li>
          </ul>

          {/* WHY REQUIRED */}
          <h2 className="section-title">
            <FaList className="icon" /> Why DSC is Required for DGFT
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Mandatory for DGFT filings</li>
            <li><FaCheckCircle /> Required for IEC and licenses</li>
            <li><FaCheckCircle /> Enables secure login</li>
            <li><FaCheckCircle /> Legally valid authentication</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits of Digital Signature
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Faster online processing</li>
            <li><FaCheckCircle /> Reduced paperwork</li>
            <li><FaCheckCircle /> Secure transactions</li>
            <li><FaCheckCircle /> Cost savings</li>
            <li><FaCheckCircle /> No physical submission required</li>
          </ul>

          {/* APPLICATIONS */}
          <h2 className="section-title">
            <FaFileInvoice className="icon" /> Applications of DSC
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> DGFT filings and licenses</li>
            <li><FaCheckCircle /> IEC registration</li>
            <li><FaCheckCircle /> GST and Income Tax filing</li>
            <li><FaCheckCircle /> e-Tendering and procurement</li>
            <li><FaCheckCircle /> Signing agreements and PDFs</li>
          </ul>

          {/* WHO CAN APPLY */}
          <h2 className="section-title">
            <FaUser className="icon" /> Who Can Apply
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Proprietor</li>
            <li><FaCheckCircle /> Partner</li>
            <li><FaCheckCircle /> Director</li>
            <li><FaCheckCircle /> Authorized Signatory</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Documents Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> PAN Card</li>
            <li><FaCheckCircle /> Aadhaar Card</li>
            <li><FaCheckCircle /> Passport size photo</li>
            <li><FaCheckCircle /> Email & mobile number</li>
            <li><FaCheckCircle /> Authorization letter (for companies)</li>
          </ul>

          {/* RENEWAL */}
          <h2 className="section-title">
            <FaSyncAlt className="icon" /> Renewal of DSC
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Expiry of certificate</li>
            <li><FaCheckCircle /> Lost or damaged token</li>
            <li><FaCheckCircle /> Change in company details</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide quick and hassle-free DSC issuance
            with complete support including documentation, application filing,
            and DGFT configuration. We ensure error-free processing and assist
            with renewal and technical support.
          </p>

        </Container>
      </section>
    </div>
  );
}